// input[type="number"] not allow only int number no float
$('input[type="number"]').on('keypress', function (event) {
  return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
});



//////////////////
// WEBPACK FOOTER
// ./src/js/components/validate/_acceptNumberOnly.js
// module id = 11
// module chunks = 0